import { create } from 'zustand';

/**
 * Cross-tree signal for auto-focusing a freshly created prompt node's editor.
 *
 * This is intentionally global: the prompt that needs focusing is a `PromptNodeV3`
 * rendered deep inside the React Flow tree, with no render relationship to the
 * menu or handle affordance that created it.
 */
interface PromptEditorFocusState {
  pendingFocusNodeId: string | null;
  setPendingFocusNodeId: (id: string | null) => void;
  consumeFocus: (id: string) => boolean;
}

export const usePromptEditorFocusStore = create<PromptEditorFocusState>((set, get) => ({
  pendingFocusNodeId: null,
  setPendingFocusNodeId: (id) => set({ pendingFocusNodeId: id }),
  consumeFocus: (id) => {
    if (get().pendingFocusNodeId !== id) return false;
    set({ pendingFocusNodeId: null });
    return true;
  },
}));
